export var getCollectionStatusLabel = function (statusRaw) {
    switch (statusRaw) {
        case "BANK_PAYMENT_PENDING":
            return "En Proceso";
        case "COMPLETED":
            return "Completado";
        case "FAILED":
            return "Fallido";
        case "PROCESSING_BANK_FILE":
            return "Procesando Pagos";
        case "GENERATING_BANK_FILE":
            return "Generando archivo";
        default:
            return statusRaw;
    }
};
export var getCollectionStatusToneBucket = function (statusRaw) {
    switch (statusRaw) {
        case "COMPLETED":
            return "COMPLETED";
        case "FAILED":
            return "FAILED";
        default:
            return "IN_PROGRESS";
    }
};
export var getCollectionTypeLabel = function (billingType) {
    switch (billingType) {
        case "GENERAL":
            return "Cobranza General";
        case "NEW":
            return "Nuevos cobros";
        case "REBILLING":
            return "Recobranza únicamente";
        default:
            return billingType;
    }
};
var MONTH_LABELS_SHORT = [
    "Ene",
    "Feb",
    "Mar",
    "Abr",
    "May",
    "Jun",
    "Jul",
    "Ago",
    "Sep",
    "Oct",
    "Nov",
    "Dic",
];
var MONTH_LABELS_FULL = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
];
export var formatCollectionListDate = function (isoDate) {
    var date = new Date(isoDate);
    if (Number.isNaN(date.getTime()))
        return isoDate;
    return "".concat(date.getDate(), " ").concat(MONTH_LABELS_SHORT[date.getMonth()], " ").concat(date.getFullYear());
};
export var getCollectionTypeShortLabel = function (billingType) {
    switch (billingType) {
        case "GENERAL":
            return "General";
        case "NEW":
            return "Nuevos";
        case "REBILLING":
            return "Recobranza";
        default:
            return billingType;
    }
};
export var formatCollectionMonthYear = function (actualMonth) {
    var date = new Date(actualMonth);
    if (Number.isNaN(date.getTime()))
        return actualMonth;
    return "".concat(MONTH_LABELS_FULL[date.getMonth()], " ").concat(date.getFullYear());
};
export var formatCollectionPeriod = function (actualMonth, billingType) {
    var monthYear = formatCollectionMonthYear(actualMonth);
    return "".concat(monthYear, " \u00B7 ").concat(getCollectionTypeShortLabel(billingType));
};
